import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const CustomAlert = ({ headerMessage, message, show, hide, callback }) => {
	const onAction = () => {
		callback();
		hide();
	};
	return (
		<Modal show={show} onHide={hide} centered>
			{headerMessage && (
				<Modal.Header closeButton>
					<Modal.Title className="modal-headers">{headerMessage}</Modal.Title>
				</Modal.Header>
			)}
			<Modal.Body>
				<div className="d-flex flex-column justify-content-center align-items-center">
					<div>{message}</div>
					<div className="w-100 mt-2 d-flex justify-content-between">
						<Button
							variant="secondary"
							onClick={() => hide()}
						>
							Close
						</Button>
						<Button
							variant="primary"
							onClick={() => onAction()}
						>
							Yes
						</Button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default CustomAlert;
